import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const TransactionsContex = createContext(defaultState);

export default TransactionsContex;
